
import { useLocaleStore } from '~/stores/locale';
export default defineNuxtPlugin(async () => {
    // Initialiser i18n et charger la langue persistante
    const { $i18n } = useNuxtApp()

    // Attendre que les stores soient chargés
    await nextTick()

    // Si vous avez un store pour la langue, l'initialiser ici
    // const settingsStore = useSettingsStore()
    // await settingsStore.loadLanguage()

    // Initialiser les stores et vue-i18n
    const localeStore = useLocaleStore();
    // console.log(localeStore.language, $i18n)
    // Initialiser la langue d'i18n avec celle du store
    $i18n.locale.value = localeStore.language;
})
